import { createSlice } from "@reduxjs/toolkit";

export const productSlice = createSlice({
  name: "product",
  initialState: {
    products: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    resetProduct: (state) => {
      state.products = [];
      state.isFetching = false;
      state.error = false;
    },
    //GET ALL
    getProductStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getProductSuccess: (state, action) => {
      state.isFetching = false;
      state.products = action.payload;
    },
    getProductFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  resetProduct,
  getProductStart,
  getProductSuccess,
  getProductFailure,
} = productSlice.actions;

export default productSlice.reducer;
